import { CommonActionTypes } from "../../action-types";

const transferMethods = JSON.parse(localStorage.getItem("transferMethods"));
const initialState = {
  transferMethods: transferMethods ? transferMethods : null,
};

export default function transferMethodsReducer(state = initialState, action) {
  switch (action.type) {
    case CommonActionTypes.GET_TRANSFER_METHODS:
      return {
        transferMethods: action.payload,
      };
    default:
      return state;
  }
}
